import { useState } from 'preact/hooks';
import { ApiError } from '../lib/api.js';
import { createGroup, openChat, startDirectChat } from '../lib/engine.js';
import { back, go } from './nav.js';

export function NewChat() {
  const [kind, setKind] = useState<'direct' | 'group'>('direct');
  const [username, setUsername] = useState('');
  const [title, setTitle] = useState('');
  const [members, setMembers] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: Event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);

    try {
      const chatId =
        kind === 'direct'
          ? await startDirectChat(username)
          : await createGroup(
              title.trim(),
              members
                .split(/[,\s]+/)
                .map((name) => name.trim())
                .filter(Boolean),
            );

      await openChat(chatId);
      // Замещаем, а не добавляем: возвращаться в форму создания уже
      // созданного чата некуда и незачем.
      go('chat', { replace: true });
    } catch (caught) {
      if (caught instanceof ApiError) {
        setError(
          caught.code === 'not_found'
            ? 'Пользователь с таким именем не найден'
            : `Ошибка: ${caught.code}`,
        );
      } else {
        setError(caught instanceof Error ? caught.message : 'Не удалось создать чат');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="screen">
      <header class="topbar">
        <button class="icon-btn" onClick={back} aria-label="Назад">
          ‹
        </button>
        <h1>Новый чат</h1>
      </header>

      <div class="scroll">
        <form class="form" onSubmit={submit}>
          <div class="row">
            <button
              type="button"
              class={`btn ${kind === 'direct' ? '' : 'subtle'}`}
              style="flex:1"
              onClick={() => setKind('direct')}
            >
              Личный
            </button>
            <button
              type="button"
              class={`btn ${kind === 'group' ? '' : 'subtle'}`}
              style="flex:1"
              onClick={() => setKind('group')}
            >
              Группа
            </button>
          </div>

          {kind === 'direct' ? (
            <label>
              Имя пользователя
              <input
                value={username}
                onInput={(event) => setUsername((event.target as HTMLInputElement).value)}
                autocapitalize="none"
                spellcheck={false}
                required
                placeholder="например, anton"
              />
            </label>
          ) : (
            <>
              <label>
                Название группы
                <input
                  value={title}
                  onInput={(event) => setTitle((event.target as HTMLInputElement).value)}
                  required
                  maxLength={100}
                />
              </label>
              <label>
                Участники — имена через запятую
                <input
                  value={members}
                  onInput={(event) => setMembers((event.target as HTMLInputElement).value)}
                  autocapitalize="none"
                  spellcheck={false}
                  required
                  placeholder="anton, maria, sergey"
                />
              </label>
            </>
          )}

          {error && <div class="error">{error}</div>}

          <button class="btn" type="submit" disabled={busy}>
            {busy ? 'Создаю…' : 'Создать'}
          </button>

          <div class="notice">
            Собеседник должен быть уже зарегистрирован — ключ чата запечатывается его
            публичным ключом в момент создания. Пригласить нового человека можно
            в настройках, выписав ему код.
          </div>
        </form>
      </div>
    </div>
  );
}
